import { gql } from '@src/lib/gql'

/**
 * Your-turn badge counts for the Advisors chrome and the site Chat icon (W3).
 *
 * One read shared by the site nav, `AdvisorsNav` and the inner rails. `advisorsAttention` has no
 * `id`, so Apollo stores it embedded under the normalized `ScoUser` and a refetch replaces it whole.
 * Self/admin only on the API; guests never send it (see `useAdvisorsAttention`).
 */
export const ADVISORS_ATTENTION = gql`
  query AdvisorsAttention {
    currentUser {
      id
      advisorsAttention {
        agreementsWaitingOnYou
        boardInvites
        unreviewedApplications
        sessionsNeedingAction
        messagesUnread
        sessionChatUnread
        total
      }
    }
  }
`

/**
 * Add to a clearing mutation's `refetchQueries` (sign, invite answer, application review, session
 * times, …) so every badge drops without waiting for the next window focus.
 */
export const ADVISORS_ATTENTION_REFETCH = { query: ADVISORS_ATTENTION }

/** Fires when the viewer reads a direct-chat thread anywhere (Inbox, `/inbox`, Messages). */
export const ADVISORS_ATTENTION_DIRECT_CHAT_VIEWED = gql`
  subscription AdvisorsAttentionDirectChatViewed {
    scoUserDirectChatViewed {
      user {
        id
        directChatThreadsUnreadCommentsCount
      }
    }
  }
`
